export default class AdParams {
  constructor() {
    this.dl_pos = 0;
  }

  setDeliveryPos(deliveryPos) {
    this.dl_pos = deliveryPos;
    return this;
  }

  setDeliveryWinner(deliveryWinner) {
    this.dl_win = deliveryWinner;
    return this;
  }

  setDeliveryCampaingId(campaingId) {
    this.dl_cid = campaingId;
    return this;
  }

  setDeliveryCreativeId(creativeID) {
    this.dl_crid = creativeID;
    return this;
  }

  setDeliveryAdDomain(adDomain) {
    this.dl_adom = adDomain;
    return this;
  }

  setDeliveryDSP(dsp) {
    this.dl_dsp = dsp;
    return this;
  }

  setPriceNetworkResponse(priceNetworkResponse) {
    this.prc_net_rs_g = priceNetworkResponse;
    return this;
  }

  setDeliveryVideoDuration(duration) {
    this.dl_vid_dur = duration && !Number.isNaN(duration) ? duration : 0;
    return this;
  }

  setErrorCode(errorCode) {
    this.err_cod = errorCode;
    return this;
  }

  setErrorType(errorType) {
    this.err_tp = errorType;
    return this;
  }

  setFormat(format) {
    this.format = format;
    return this;
  }

  setAdRealSize(adRealSize) {
    this.ad_sz_rl = adRealSize;
    return this;
  }

  setAdType(adType) {
    this.ad_tp = adType;
    return this;
  }

  setExtraClient(value) {
    this.ext_cli = value;
  }

  build() {
    return {
      dl_pos: this.dl_pos,
      dl_win: this.dl_win,
      dl_cid: this.dl_cid,
      dl_crid: this.dl_crid,
      dl_adom: this.dl_adom,
      dl_dsp: this.dl_dsp,
      prc_net_rs_g: this.prc_net_rs_g,
      err_cod: this.err_cod,
      err_tp: this.err_tp,
      format: this.format,
      ad_sz_rl: this.ad_sz_rl,
      ad_tp: this.ad_tp,
      ext_cli: this.ext_cli,
    };
  }
}
